import React, { useEffect } from "react";
import styles from "./Print.module.css";

import { useReactToPrint } from "react-to-print";
import Button from "../components/Button";
//import { ComponentToPrint } from "../ComponentToPrint";

function PrintEventFOH({ eventData, serverData }) {
  const componentRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  let parentQty;

  const getTimeValue = (aDate) => {
    if (!aDate) {
      return;
    }

    let hours;
    let minutes;
    if (aDate.length == 8) {
      hours = Number(aDate.substring(0, 2));
      minutes = Number(aDate.substring(3, 5));
    } else {
      let theDate = new Date(aDate.slice(0, -1));
      hours = theDate.getHours();
      minutes = theDate.getMinutes();
    }

    if (hours != 0) {
      return `${hours > 12 ? hours - 12 : hours}:${minutes < 10 ? "0" + minutes : minutes} ${hours >= 12 ? "pm" : "am"}`;
    }
  };

  const apps = eventData.details.filter((el) => el.Category.startsWith("APP"));
  const ents = eventData.details.filter(
    (el) => el.Category.startsWith("ENT") || el.Category.startsWith("BUF") || el.Category.startsWith("DIN") || el.Category == "SIDE"
  );
  const dess = eventData.details.filter((el) => el.Category == "DES");

  useEffect(() => {
    reactToPrintFn();
  }, []);

  return (
    <>
      <div className="printOnly">
        <div ref={contentRef}>
          <div className={styles.printFrame}>
            <div className={`${styles.printSection1of1} ${styles.center} ${styles.pt1}`}>
              <span className={styles.titleBox}>BOH</span>
            </div>
            <div className={styles.flexSection}>
              {/* Header Area */}
              <div className={styles.printSection1of2}>
                <h3>EVENT: {eventData.BanquetName}</h3>
              </div>
              <div className={`${styles.printSection1of2} ${styles.right}`}>
                <h3>EVENT DATE: {new Date(eventData.BanDate.slice(0, -1)).toDateString()}</h3>
              </div>
            </div>
            <hr className={`${styles.printSection1of1} ${styles.my1}`} />

            <div className={styles.flexSection}>
              <div className={styles.printSection1of2}>
                <div className={styles.contactInfo}>
                  <h5>Event Details</h5>
                  <table className={styles.timeTable}>
                    <tbody>
                      <tr>
                        <td>Arrival</td>
                        <td>{getTimeValue(eventData.BanArrivalTime)}</td>
                      </tr>
                      <tr>
                        <td>Apps</td>
                        <td>{getTimeValue(eventData.AppTime)}</td>
                      </tr>
                      <tr>
                        <td>Entrees</td>
                        <td>{getTimeValue(eventData.BanMealTime)}</td>
                      </tr>
                      <tr>
                        <td>Dessert</td>
                        <td>{getTimeValue(eventData.DessertTime)}</td>
                      </tr>
                      <tr>
                        <td>Departure</td>
                        <td>{getTimeValue(eventData.DepartureTime)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className={`${styles.printSection1of2} ${styles.right}`}>
                <div className={styles.serverInfo}>
                  <h5>Servers</h5>
                  {serverData.map((sd) => {
                    if (sd.category == "Server") {
                      return <p key={sd.ServerName}>{sd.ServerName}</p>;
                    }
                  })}
                </div>
              </div>
            </div>
            <hr className={`${styles.printSection1of1} ${styles.my1}`} />
            <div className={`${styles.printSection1of1} ${styles.printContent}`}>
              <div className={styles.printSection1of3}>
                Guest Count: <b>{eventData.BanAttendance}</b>
              </div>
              <div className={`${styles.printSection1of3} ${styles.center}`}>
                Banquet Room: <b>{eventData.RoomName}</b>
              </div>
              <div className={`${styles.printSection1of3} ${styles.right}`}>
                Service Type: <b>{eventData.ServiceTypeName}</b>
              </div>
            </div>
            <hr className={`${styles.printSection1of1} ${styles.my1}`} />

            <div className={`${styles.printSection1of1}`}>
              <div>
                <h3 className={styles.my2}>MENU NOTES</h3>
                <table className={`${styles.notesTable}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          APPS: <span style={{ marginLeft: 1 + "rem" }}>{getTimeValue(eventData.AppTime)}</span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apps.length > 0 ? (
                      apps.map((el) => {
                        let notelist = String(el.menuItemNotes).split("\n");

                        if (el.isParent) {
                          parentQty = el.qty;
                        }
                        return (
                          <tr>
                            <td>{el.isParent ? el.item : <span className={styles.subItem}>{el.item}</span>}</td>
                            <td>{el.isParent ? el.qty : ""}</td>
                            <td>
                              <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>No Apps</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <table className={`${styles.notesTable}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          ENTREES: <span style={{ marginLeft: 1 + "rem" }}>{getTimeValue(eventData.BanMealTime)}</span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ents.length > 0 ? (
                      ents.map((el) => {
                        let notelist = String(el.menuItemNotes).split("\n");
                        if (el.isParent) {
                          parentQty = el.qty;
                        }
                        return (
                          <tr>
                            <td>{el.isParent ? el.item : <span className={styles.subItem}>{el.item}</span>}</td>
                            <td>{el.isParent ? el.qty : ""}</td>
                            <td>
                              <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>No Entrees</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <table className={`${styles.notesTable}`}>
                  <thead>
                    <tr>
                      <th>
                        <h4>
                          DESSERTS: <span style={{ marginLeft: 1 + "rem" }}>{getTimeValue(eventData.DessertTime)}</span>
                        </h4>
                      </th>
                      <th>Qty</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dess.length > 0 ? (
                      dess.map((el) => {
                        let notelist = String(el.menuItemNotes).split("\n");
                        if (el.isParent) {
                          parentQty = el.qty;
                        }
                        return (
                          <tr>
                            <td>{el.isParent ? el.item : <span className={styles.subItem}>{el.item}</span>}</td>
                            <td>{el.isParent ? el.qty : ""}</td>
                            <td>
                              <pre>{String(el.menuItemNotes) != "null" ? String(el.menuItemNotes) : ""}</pre>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>No Desserts</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className={`${styles.printSection1of1} ${styles.borderedDiv} ${styles.mb1} ${styles.pageBreak}`}>
              <h5>Event Notes:</h5>
              <div style={{ whiteSpace: "pre-line" }}>{String(eventData.EventNotes) == "null" ? "" : String(eventData.EventNotes)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrintEventFOH;
